module.exports = __webpack_public_path__ + "static/media/daniel-bleuer.43bc66d6.jpg";